@if (team) {
  <div>
    <span class="teamname">{{team.name}}</span>
    <div class="planwrapper">
      @if (companyPlusPlan) {
        <div class="plans currentplan">
          <span class="planname">Plus plan</span>
          <span class="rate">Included</span>
        </div>
      }
      @for (plan of companyPlusPlan ? [] : plans; track plan) {
        <div [class]="team.plan === plan.plan ? 'plans currentplan' : 'plans'">
          <span class="planname">{{plan.name}}</span>
          <span class="rate">{{plan.rate}}</span>
          <button mat-raised-button [disabled]="team.plan === plan.plan || (!team.defaultPaymentMethod && plan !== plans[0]) || !isTeamApproved" color="primary" class="editbutton" (click)="selectPlan(plan)">
            {{team.plan === plan.plan ? 'Current Plan' : buttonMessage(plan)}}
          </button>
        </div>
      }
    </div>
    @if (!team.defaultPaymentMethod && !companyPlusPlan) {
      <span>After you have selected a payment method, you may then choose a different paid plan.</span>
    }
  </div>
}
